// extracted by mini-css-extract-plugin
module.exports = {"searchbar":"searchbar_searchbar__xbZ_m","searchbarContainer":"searchbar_searchbarContainer__vAGF4","textWrapper":"searchbar_textWrapper__XAy6s"};